import React from "react";
import { SVGICONS } from "config";
import { t } from "i18next";

// Todo: Remove this component after the delivery/pickup ui revamped
const LoginHeader = ({ goBack }) => {
  return (
    <React.Fragment>
      {/* Header */}
      <div className="my-1 py-5 flex items-center">
        <button onClick={goBack}>
          <SVGICONS.BackArrow />
        </button>
        <h4 className="flex-1 text-center text-20x font-bold text-shadow-forge-900">{t("Verification")}</h4>
      </div>
      {/* Title */}
      <h2 className="my-1 py-5 text-24x font-bold leading-32x">
        <span className="text-shadow-forge-800">{t("Enter your")}</span>
        <span className="blinking-login-header px-2 text-brand-base-primary">
          {t("WhatsApp")}
        </span>
      </h2>
      {/* Description */}
      <p className="text-14x leading-19x text-shadow-forge-700 max-w-70">
        {t(
          "We will send you a WhatsApp message with a one-time verification code"
        )}
      </p>
    </React.Fragment>
  );
};

export default LoginHeader;
